import { lazy } from 'react';

const Users = lazy(() => import('../pages/users'));
const Companies = lazy(() => import('../pages/companies'));
const CompanyDetails = lazy(() => import('../pages/companies/company-details'));
const Documents = lazy(() => import('../pages/documents'));
const Profile = lazy(() => import('../pages/profile'));
const Home = lazy(() => import('../pages/home'));
const SyncHistory = lazy(() => import('../pages/sync-history'));
const UserTabs = lazy(() => import('../pages/user'));
const CoompanySyncHistory = lazy(() => import('../pages/sync-by-company'));
// const Configurations= lazy(()=> import('../pages/configurations'))
const ImportConfig = lazy(() => import('../pages/import-config'));
const EditConfig = lazy(() => import('../pages/import-config/edit-config'));
const AddNewConfig = lazy(() => import('../pages/import-config/add-config'));
const FeatureFlags = lazy(() => import('../pages/feature-flags'));
const NavigationItems = lazy(() => import('../pages/navigation-items'));
const AnnouncementsPage = lazy(() => import('../pages/announcements'));
const SubscriptionManagement = lazy(() => import('../pages/subscription-management'));
const SubscriptionHistory = lazy(() => import('../pages/subscription-management/subscription-history'));
const SubscriptionTypesManagement = lazy(() => import('../pages/subscription-management/subscription-types'));
const MaterializedViews = lazy(() => import('../pages/materialized-views'));
const PaymentBindings = lazy(() => import('../pages/payment-bindings'));
const TicketReview = lazy(() => import('../pages/ticket-review'));
const DashboardBuilder = lazy(() => import('../pages/dashboard-builder'));
const DashboardEditor = lazy(() => import('../pages/dashboard-builder/editor'));
const Datasets = lazy(() => import('../pages/datasets'));
const PredefinedReports = lazy(() => import('../pages/predefined-reports'));
const ViewReport = lazy(() => import('../pages/predefined-reports/view-report'));

const coreRoutes = [
  {
    path: '/users',
    title: 'Users',
    component: Users,
  },
  {
    path: '/users/:id',
    title: 'Users',
    component: UserTabs,
  },
  {
    path: '/companies',
    title: 'Companies',
    component: Companies,
  },
  {
    path: '/documents',
    title: 'Documents',
    component: Documents,
  },
  {
    path: '/companies/:id',
    title: 'CompanyDetails',
    component: CompanyDetails,
  },
  {
    path: '/sync_history',
    title: 'SyncHistory',
    component: SyncHistory,
  },
  {
    path: '/',
    title: 'HomePage',
    component: Home,
  },
  {
    path: '/profile',
    title: 'Profile',
    component: Profile,
  },
    // {
    //     path:'/configs',
    //     title:'Configurations',
    //     component:Configurations
    // },
  {
    path: '/excel-config',
    title: 'Excel Configuration',
    component: ImportConfig,
  },
  {
    path: '/excel-config/:filename',
    title: 'Mapping Configuration',
    component: EditConfig,
  },
  {
    path: '/excel-config/new',
    title: 'Add new Configuration',
    component: AddNewConfig,
  },
  {
    path: '/feature-flags',
    title: 'Feature Management',
    component: FeatureFlags,
  },
  {
    path: '/navigation-items',
    title: 'Navigation Management',
    component: NavigationItems,
  },
  {
    path: '/announcements',
    title: 'Announcements Management',
    component: AnnouncementsPage,
  },
  {
    path: '/subscription-management',
    title: 'Subscription Management',
    component: SubscriptionManagement,
  },
  {
    path: '/subscription-history',
    title: 'Subscription History',
    component: SubscriptionHistory,
  },
  {
    path: '/subscription-types',
    title: 'Subscription Types Management',
    component: SubscriptionTypesManagement,
  },
  {
    path: '/materialized-views',
    title: 'Materialized Views',
    component: MaterializedViews,
  },
  {
    path: '/payment-bindings',
    title: 'Payment Bindings',
    component: PaymentBindings,
  },
  {
    path: '/ticket-review',
    title: 'Ticket Review',
    component: TicketReview,
  },
  {
    path: '/dashboard-builder',
    title: 'Dashboard Builder',
    component: DashboardBuilder,
  },
  {
    path: '/dashboard-builder/:id/edit',
    title: 'Edit Dashboard',
    component: DashboardEditor,
  },
  {
    path: '/datasets',
    title: 'Dataset Management',
    component: Datasets,
  },
  {
    path: '/predefined-reports',
    title: 'Predefined Reports',
    component: PredefinedReports,
  },
  {
    path: '/analytics/reports/:id/view',
    title: 'View Report',
    component: ViewReport,
  },
];

const routes = [...coreRoutes];
export default routes;
